module.exports = __webpack_public_path__ + "img/coupon-item-valid-bg.58a79a50.png";